export const ROLE_RANK: Record<string, number> = {
  admin: 4,
  attorney: 3,
  paralegal: 2,
  intake_supervisor: 2,
  staff: 1,
  intake: 1,
};

export function getRoleRank(role: string | null | undefined, fallback = 1): number {
  return ROLE_RANK[role ?? ''] ?? fallback;
}

/**
 * Who works the creditor match-review queue (#1434).
 *
 * Not expressible as a `minRole` rank: `intake` ranks 1 and `intake_supervisor`
 * ranks 2, so any rank threshold low enough to admit them also admits
 * `paralegal` and `attorney`, who are deliberately outside this queue. Deciding
 * which creditor a contact belongs to is intake's judgment; `admin` is here for
 * oversight.
 *
 * Mirrors `require_role("admin", "intake_supervisor", "intake")` in
 * `app/api/creditor_canonicalization.py`. Shared by the route guard and the
 * sidebar entry so a user can never see a link to a page the API will refuse.
 */
export const CREDITOR_MATCH_REVIEW_ROLES = ['admin', 'intake_supervisor', 'intake'];

/**
 * Who can view and act on evidence escalations (#1831).
 *
 * Formerly gated at the top-level route by StaffRoute and minRole: 'intake'
 * on the sidebar navigation item. Preserves the same staff access boundary now
 * that Evidence Escalations lives as a subtab under Documents.
 */
export const EVIDENCE_ESCALATIONS_ROLES = ['admin', 'attorney', 'paralegal', 'intake_supervisor', 'intake', 'staff'];

export function canAccessEvidenceEscalations(role: string | null | undefined): boolean {
  return typeof role === 'string' && EVIDENCE_ESCALATIONS_ROLES.includes(role);
}
